<template>
    <Card>
        <CardArtwork class="tw-cursor-pointer"
                     :to="{name: 'service', params: {service: service.id}}"
                     :src="service.image(300)"></CardArtwork>
        <CardTitle :title="service.title"
                   :to="{name: 'service', params: {service: service.id}}" />
        <CardBuyButton :item="service" />
    </Card>
</template>

<script>
import Card from "../../base/base-card/BaseCard";
import CardArtwork from "../../base/base-artwork";
import CardTitle from "../../base/base-card/BaseCardTitle";
import CardBuyButton from "../../base/base-card/BaseCardBuyButton";
import PlayButton from "../../base/base-play";

export default {
    components: { CardBuyButton, CardTitle, PlayButton, CardArtwork, Card },
    props: {
        service: {
            type: Object,
            required: true
        }
    },
    computed: {},
    methods: {}
};
</script>
